import { Component } from "@angular/core";
import { Store } from "@ngrx/store";

import {
  filterByLogon,
  setEmptyData,
} from "../../../users/state/actions/user.actions";

@Component({
    selector: "pl-search-form",
    templateUrl: "./search-form.component.html",
    styleUrls: ["./search-form.component.scss"],
    standalone: false
})
export class SearchFormComponent {
  public inputError = false;
  public searchValue = "";

  constructor(private readonly store: Store) {}

  public searchUser(logon: string, reset: boolean): void {
    this.searchValue = logon || "";
    localStorage.setItem("searchValue", this.searchValue);

    if (reset) {
      this._clearSearch();
    }

    if (logon && this._isSearchMinLength(logon)) {
      this.store.dispatch(setEmptyData());
    } else {
      this.store.dispatch(filterByLogon({ logon: this.searchValue || "" }));
    }
  }

  private _isSearchMinLength(textSearch: string): boolean {
    const MIN_LENGTH = 7; // bussiness Rule
    return textSearch?.length < MIN_LENGTH;
  }

  private _clearSearch(): void {
    const searchInput = window.document.getElementById(
      "mat-input-0",
    ) as HTMLInputElement;
    localStorage.removeItem("searchValue");
    if (searchInput) {
      searchInput.value = "";
    }
  }
}
